module.exports = __webpack_public_path__ + "static/media/chicken-nuggets-fr.e94b5b67.jpg";